// src/components/TrainingCards/TrainingCards.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchTrainingCards,
  deleteTrainingCard,
} from "../../../store/trainingCardsSlice";

import {
  insertTrainingCard,
  updateTrainingCard,
} from "../../../store/trainingCardsSlice";
import { insertTrainingSchedule,fetchTrainingSchedules } from "../../../store/trainingSchedulesSlice";

import { fetchICTData }           from "../../../store/uiSlice";
import { fetchEmployees }         from "../../../store/empDataSlice";
import { fetchHoursByICTId }      from "../../../store/hoursSlice";
import { fetchTrainers }          from "../../../store/trainersSlice";
import { fetchTourData }          from "../../../store/tourDataSlice";
import { fetchTravelData }        from "../../../store/travelDataSlice";
import { fetchAccommodations }    from "../../../store/accommodationSlice";
import { insertICTSalesCard }     from "../../../store/ictSalesCardSlice";
import { fetchMiscExpenses }      from "../../../store/miscExpenseDataSlice";
import { fetchLearners }          from "../../../store/learnersSlice";  
import { insertLearnerAttendance } from "../../../store/learnerAttendanceSlice";
import CompleteTrainingDetail     from "./subComponents/trainingCard/CompleteTrainingDetail";
import LearnerAttendanceList       from "./subComponents/learner/LearnerAttendanceList";
import "../../../Styles/Common.css";
import { ToastContainer, toast }  from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/* ════════════════════════════════════════════════════════════════════════
   CHILD COMPONENT  – Add / Edit Training-Card (unchanged core logic)
   ══════════════════════════════════════════════════════════════════════ */
const AddEditTrainingCard = ({ initCardObj, onClose }) => {
  const dispatch = useDispatch();

  /* ——— global data ——— */
  const { ictData = [] }    = useSelector(s => s.ui);
  const { trainers = [] }   = useSelector(s => s.trainers);
  const { employees = [] }  = useSelector(s => s.empData);
  
  const {
    hoursByIct = {},      // your older reducer name
    byIct      = {},      // new reducer name (if you changed it)
  } = useSelector(s => s.hours);
  const hoursMap = Object.keys(hoursByIct).length ? hoursByIct : byIct;

  /* ——— local state ——— */
  const [formCard, setFormCard] = useState(
    initCardObj ?? {
      id: "",
      ictId_id: "",
      ictTrainerId: "",
      batchStartDate: "",
      batchEndDate: "",
      batchStartTime: "",
      batchEndTime: "",
      ictStudyMode: "",
      ictLocation: "",
      ictHours: 0,
      isCustom: 0,
      isPublic: 1,
      status: "A",
    }
  );

  const [ictText,      setIctText]      = useState("");
  const [ictSug,       setIctSug]       = useState([]);
  const [trainerText,  setTrainerText]  = useState("");
  const [trainerSug,   setTrainerSug]   = useState([]);

  const [trainingSum,  setTrainingSum]  = useState(0);
  const [labSum,       setLabSum]       = useState(0);

  /* ——— pre-fill names when editing ——— */
  useEffect(() => {
    if (initCardObj?.ictId_id) {
      const ict = ictData.find(i => i.id === initCardObj.ictId_id);
      if (ict) setIctText(ict.ictName);
    }
    if (initCardObj?.ictTrainerId) {
      const tr  = trainers.find(t => t.id === initCardObj.ictTrainerId);
      const emp = employees.find(e => e.id === tr?.empId);
      if (emp) setTrainerText(`${emp.empFName} ${emp.empLName}`);
    }
  }, [initCardObj, ictData, trainers, employees]);

  /* ——— fetch hours when ICT chosen ——— */
  useEffect(() => {
    if (formCard.ictId_id) dispatch(fetchHoursByICTId(formCard.ictId_id));
  }, [formCard.ictId_id, dispatch]);

  /* ——— recompute hour sums ——— */
  useEffect(() => {
    const list = hoursMap[formCard.ictId_id] ?? [];
    const tSum = list.reduce((s, h) => s + +(h.TrainingHour ?? 0), 0);
    const lSum = list.reduce((s, h) => s + +(h.LabHour      ?? 0), 0);
    setTrainingSum(tSum);
    setLabSum(lSum);
  }, [formCard.ictId_id, hoursByIct]);

  /* ——— helper ——— */
  const calcDays = (s, e) =>
    Math.ceil((new Date(e) - new Date(s)) / 86_400_000) + 1;
  const spanHrs = (s, e) => {
    const sh = +s.split(":")[0], eh = +e.split(":")[0];
    return eh >= sh ? eh - sh : eh + 24 - sh;
  };

  /* ——— auto-update ictHours ——— */
  useEffect(() => {
    const { batchStartDate, batchEndDate, batchStartTime, batchEndTime } = formCard;
    if (batchStartDate && batchEndDate && batchStartTime && batchEndTime) {
      const days    = calcDays(batchStartDate, batchEndDate);
      const hours   = spanHrs(batchStartTime, batchEndTime);
      const total   = days * hours;
      setFormCard((prev) => ({ ...prev, ictHours: total }));
    }
  }, [
    formCard.batchStartDate,
    formCard.batchEndDate,
    formCard.batchStartTime,
    formCard.batchEndTime,
  ]);

  /* ——— live search ICT ——— */
  const handleICTInput = e => {
    const v = e.target.value;
    setIctText(v);
    if (v.length >= 3) {
      setIctSug(
        ictData.filter(i => i.ictName.toLowerCase().includes(v.toLowerCase()))
      );
    } else setIctSug([]);
  };
  // const chooseICT = ict => {
  //   setFormCard({ ...formCard, ictId_id: ict.id });
  //   setIctText(ict.ictName);
  //   setIctSug([]);
  // };
  const chooseICT = ict => {
    setFormCard(prev => ({ ...prev, ictId_id: ict.id }));
    setIctText(ict.ictName);
    setIctSug([]);
  
    // 👉 trigger hour-fetch instantly so the UI updates right away
    dispatch(fetchHoursByICTId(ict.id));
  };

  /* ——— live search Trainer ——— */
  const handleTInput = e => {
    const v = e.target.value;
    setTrainerText(v);
    if (v.length >= 3) {
      const sug = trainers.filter(t => {
        const emp = employees.find(e => e.id === t.empId);
        return emp && (`${emp.empFName} ${emp.empLName}`)
          .toLowerCase()
          .includes(v.toLowerCase());
      });
      setTrainerSug(sug);
    } else setTrainerSug([]);
  };
  const chooseTrainer = t => {
    setFormCard({ ...formCard, ictTrainerId: t.id });
    const emp = employees.find(e => e.id === t.empId);
    setTrainerText(emp ? `${emp.empFName} ${emp.empLName}` : "");
    setTrainerSug([]);
  };
  /* ——— submit ——— */
  const handleSubmit = async e => {
    e.preventDefault();
    if (formCard.ictHours !== trainingSum + labSum) {
      toast.error("Schedule hours must equal Training + Lab hours");
      return;
    }
    try {
      if (formCard.id) {
        await dispatch(updateTrainingCard(formCard)).unwrap();
        toast.success("Training-card updated");
      } else {
        await dispatch(insertTrainingCard(formCard)).unwrap();
        toast.success("Training-card created");
      }
      onClose();
    } catch {
      toast.error("Save failed");
    }
  };

  /* ——— UI ——— */
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>{formCard.id ? "Edit Training" : "Add Training"}</h2>

        <form onSubmit={handleSubmit}>
          {/* ICT search */}
          <div className="form-group">
            <label>ICT Name</label>
            <input value={ictText} onChange={handleICTInput} required/>
            {ictSug.length > 0 && (
              <div className="suggestions-dropdown">
                {ictSug.map(i => (
                  <div key={i.id}
                       className="suggestion-item"
                       onClick={() => chooseICT(i)}>
                    {i.ictName}
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* Hours preview */}
          <div className="doubleFormField">
            <div className="form-group halfForm">
              <label>Training+Lab</label>
              <input readOnly value={trainingSum + labSum} />
            </div>
            <div className="form-group halfForm">
              <label>Schedule Hours</label>
              <input readOnly value={formCard.ictHours} />
            </div>
          </div>
          {/* Trainer search */}
          <div className="form-group">
            <label>Trainer</label>
            <input value={trainerText} onChange={handleTInput} required/>
            {trainerSug.length > 0 && (
              <div className="suggestions-dropdown">
                {trainerSug.map(t => {
                  const emp = employees.find(e => e.id === t.empId);
                  return (
                    <div key={t.id}
                         className="suggestion-item"
                         onClick={() => chooseTrainer(t)}>
                      {emp ? `${emp.empFName} ${emp.empLName}` : "Unknown"}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* hidden trainer id */}
          <input type="hidden" value={formCard.ictTrainerId} />

          {/* dates/times */}
          <div className="form-group">
            <div className="batchStartEndDate">
              <label>Batch Start Date & Batch Start Time</label>
              <label>Batch End Date & Batch End Time</label>
            </div>
            <div className="batchStartEndDate">
              <input type="date"
                     value={formCard.batchStartDate}
                     onChange={e => setFormCard({ ...formCard, batchStartDate:e.target.value })}
                     required/>
              <input type="time"
                     value={formCard.batchStartTime}
                     onChange={e => setFormCard({ ...formCard, batchStartTime:e.target.value })}
                     required/>
                     &nbsp;
              <input type="date"
                     value={formCard.batchEndDate}
                     onChange={e => setFormCard({ ...formCard, batchEndDate:e.target.value })}
                     required/>
                     &nbsp;
              <input type="time"
                     value={formCard.batchEndTime}
                     onChange={e => setFormCard({ ...formCard, batchEndTime:e.target.value })}
                     required/>
            </div>
          </div>

          {/* mode & location */}
          <div className="form-group">
            <label>Study Mode</label>
            <select value={formCard.ictStudyMode}
                    onChange={e => setFormCard({ ...formCard, ictStudyMode:e.target.value })}
                    required>
              <option value="">Select</option>
              <option value="Online">Online</option>
              <option value="Offline">Offline</option>
              <option value="Hybrid">Hybrid</option>
            </select>
          </div>
          <div className="form-group">
            <label>Location</label>
            <input value={formCard.ictLocation}
                   onChange={e => setFormCard({ ...formCard, ictLocation:e.target.value })}
                   required/>
          </div>

          {/* flags */}
          <div>
            <label>
              <input type="checkbox"
                     checked={formCard.isPublic === 1}
                     onChange={e => setFormCard({ ...formCard, isPublic:e.target.checked?1:0 })}/>
              Public
            </label>
            <label style={{ marginLeft:"1rem" }}>
              <input type="checkbox"
                     checked={formCard.isCustom === 1}
                     onChange={e => setFormCard({ ...formCard, isCustom:e.target.checked?1:0 })}/>
              Custom
            </label>
          </div>

          {/* actions */}
          <div className="form-actions">
            <button type="submit">
              {formCard.id ? <i className="fa fa-edit"/> : <i className="fa fa-plus-square"/>}
            </button>
            <button type="button"
                    className="close-btn fa fa-close"
                    onClick={onClose}/>
          </div>
        </form>
      </div>
    </div>
  );
};

const TrainingCards = () => {
  const dispatch = useDispatch();

  /* ——— global slices ——— */
  const { trainingCards, loading: tcLoading, error: tcError } = useSelector(s => s.trainingCards);
  const { ictData,       loading: ictLoading, error: ictError } = useSelector(s => s.ui);

  const {
    tourData,        loading: tourLoading,   error: tourError
  } = useSelector(s => s.tourData);
  const {
    travelData,      loading: travelLoading, error: travelError
  } = useSelector(s => s.travelData);
  const {
    accommodations,  loading: accLoading,    error: accError
  } = useSelector(s => s.accommodations);
  const {
    miscExpenses = [], loading: meLoading, error: meError
  } = useSelector(s => s.miscExpenseData);
  const { learners = [] }  = useSelector(s => s.learners); 

  /* ——— local UI state ——— */
  const [filters, setFilters]       = useState({ name:"", year:"", month:"", all:false });
  const [page,    setPage]          = useState(1);
  const [detail,  setDetail]        = useState(null);
  const [formObj, setFormObj]       = useState(null);   // null→closed
  const [attTcId, setAttTcId]       = useState(null);
  const { schedules = [] } = useSelector((s) => s.trainingSchedules);

  /* ——— effects: initial fetch ——— */
  useEffect(() => {
    dispatch(fetchTrainingCards());
    dispatch(fetchICTData());
    dispatch(fetchTourData());
    dispatch(fetchTravelData());
    dispatch(fetchAccommodations());
    dispatch(fetchEmployees());
    dispatch(fetchTrainers());
    dispatch(fetchMiscExpenses()); 
    dispatch(fetchLearners());
    dispatch(fetchTrainingSchedules());
  }, [dispatch]);

  /* ——— helper ——— */
  const daysBetween = (s, e) => Math.ceil((new Date(e) - new Date(s)) / 86_400_000) + 1;
/* ——— schedule-presence helper ——— */
  const hasSchedule = (tcId) =>
    schedules.some((sch) => Number(sch.ictTC_id) === Number(tcId));
  /* ——— filter list ——— */
  const filtered = trainingCards
    .filter(c => {
      const ict = ictData.find(i => i.id === c.ictId_id);
      const nameMatch = (ict?.ictName || "").toLowerCase().includes(filters.name.toLowerCase());
      const notExpired = filters.all || new Date(c.batchEndDate) >= new Date();
      const y = new Date(c.batchStartDate).getFullYear();
      const m = new Date(c.batchStartDate).getMonth() + 1;
      return nameMatch &&
             (!filters.year  || y === +filters.year) &&
             (!filters.month || m === +filters.month) &&
             notExpired;
    })
    .sort((a, b) => new Date(b.batchStartDate) - new Date(a.batchStartDate));

  const perPage     = 9;
  const totalPages  = Math.ceil(filtered.length / perPage);
  const pageItems   = filtered.slice((page - 1) * perPage, page * perPage);

  /* ────────────────────────────────────────────────────────────────
     Generate ICT-Sales-Card  (only in MAIN component!)
     ─────────────────────────────────────────────────────────────── */
  const generateSC = async card => {
    if (!card?.id || !card?.ictId_id) {
      toast.error("Invalid training-card");
      return;
    }

    const tour   = (tourData        ?? []).filter(t => +t.tc_id === +card.id)
                      .reduce((s, t) => s + +(t.tourCost          ?? 0), 0);
    const travel = (travelData      ?? []).filter(t => +t.tc_id === +card.id)
                      .reduce((s, t) => s + +(t.travelCost        ?? 0), 0);
    const accom  = (accommodations  ?? []).filter(a => +a.tc_id === +card.id)
                      .reduce((s, a) => s + +(a.accommodationCost ?? 0), 0);
    const misc   = (miscExpenses    ?? []).filter(m => +m.tc_id === +card.id)
                      .reduce((s, m) => s + +(m.meCost            ?? 0), 0);

    const payload = {
      ict_id            : card.ictId_id,
      trainer_id        : card.ictTrainerId?.toString() || "",
      trainingCard_id   : card.id.toString(),
      status            : "A",

      tourBills         : tour,
      travelBills       : travel,
      accommodationBills: accom,
      meBills           : misc,
      dcLabIncluded        : "N",
      dcLab_id             : null,

      tourIncluded         : card.ictStudyMode === "Online" ? "N" : "Y",
      tourBill_id          : null,
      travelIncluded       : card.ictStudyMode === "Online" ? "N" : "Y",
      travelBill_id        : null,
      accommodationIncluded: card.ictStudyMode === "Online" ? "N" : "Y",
      accommodationBill_id : null,
    };

    try {
      await dispatch(insertICTSalesCard(payload)).unwrap();
      toast.success(`SC generated!  Tour ₹${tour} | Travel ₹${travel} | Stay ₹${accom}`);
    } catch {
      toast.error("Generate SC failed");
    }
  };
 /* ────────────────────────────────────────────────────────────────
+     Generate **Training Schedule**
+     scheduleStart  = batchStartDate + "T" + batchStartTime
+     scheduleEnd    = batchEndDate   + "T" + batchEndTime
+     totalHours     = difference (in h) between those two moments
+     ictTC_id       = training-card id
+     ─────────────────────────────────────────────────────────────── */
  const makeIso = (d, t) => `${d}T${t.length === 5 ? t : t.slice(0,5)}:00`;

  const generateSchedule = async (card) => {
    if (!card?.batchStartDate || !card?.batchEndDate) {
      toast.error("Card is missing start/end date");
      return;
    }

    const totalHours = (() => {
      const sh = +card.batchStartTime.split(":")[0];
      const eh = +card.batchEndTime.split(":")[0];
      return eh >= sh ? eh - sh : eh + 24 - sh;
    })();

    // walk day-by-day
    const start = new Date(card.batchStartDate);
    const end   = new Date(card.batchEndDate);
    const jobs  = [];
    const learnersOfCard = learners.filter(
      (lrn) => Number(lrn.trainingId) === Number(card.id)
    );
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const yyyy_mm_dd = d.toISOString().substring(0, 10);          // 2025-04-02
      jobs.push(
        dispatch(insertTrainingSchedule({
          ictTC_id   : card.id,                     // FK to training-card
          totalHours,
          scheduleStart: `${yyyy_mm_dd}T${card.batchStartTime}`,
          scheduleEnd  : `${yyyy_mm_dd}T${card.batchEndTime}`,
          status: "A",
        })).unwrap()
      );
      learnersOfCard.forEach((lrn) => {
        jobs.push(
          dispatch(
            insertLearnerAttendance({
              tc_id          : card.id,
              learnerId      : lrn.id,
              AttendanceDate : yyyy_mm_dd,    // only the date part
              Attendance     : "A",           // default to ‘A’  (Absent)
              status         : "A",
            })
          ).unwrap()
        );
      });
    }

    try {
      await Promise.all(jobs);
        toast.success(
          `Schedule & attendance created – ${(end-start)/86_400_000 + 1} day(s), ` +
          `${learnersOfCard.length} learner(s)`
        );
    } catch {
      toast.error("Failed to generate schedule");
    }
  };

  /* ——— render ——— */
  return (
    <div className="training-cards-container">
      <div className="header-container">
        <h2>Training Assignments</h2>
        <button className="add-lead-btn" onClick={() => setFormObj({})}>
          <i className="fa fa-plus" />
        </button>
      </div>

      {(tcLoading || ictLoading || tourLoading || travelLoading || accLoading) && (
        <p>Loading…</p>
      )}
      {(tcError || ictError || tourError || travelError || accError) && (
        <p className="error">
          {tcError || ictError || tourError || travelError || accError}
        </p>
      )}

      {/* filters */}
      <div className="search-section_leads">
        <input
          className="filter-input"
          placeholder="ICT name"
          value={filters.name}
          onChange={e => setFilters({ ...filters, name: e.target.value })}
        />
        <div>
          <select
            className="filter-input"
            value={filters.year}
            onChange={e => setFilters({ ...filters, year: e.target.value })}
          >
            <option value="">Year</option>
            {[...new Set(trainingCards.map(t =>
              new Date(t.batchStartDate).getFullYear()))]
              .sort((a, b) => a - b)
              .map(y => <option key={y}>{y}</option>)}
          </select>
          <select
            className="filter-input"
            value={filters.month}
            onChange={e => setFilters({ ...filters, month: e.target.value })}
          >
            <option value="">Month</option>
            {["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
              .map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
          </select>
        </div>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={filters.all}
            onChange={() => setFilters({ ...filters, all: !filters.all })}
          /> Show All
        </label>
      </div>

      {/* card grid */}
      <div className="cards">
        {pageItems.map(card => {
          const ict = ictData.find(i => i.id === card.ictId_id);
          return (
            <div key={card.id} className="card" onClick={() => setDetail(card)}>
              <h3>
                {ict?.ictName || "Unknown"}
              </h3>
              <hr />
              <div className="cardBody">
                <div className="cardBodyLeft">
                  <p><strong className="fa fa-calendar-alt" /> : {card.batchStartDate} – {card.batchEndDate}</p>
                  <p><strong className="fa fa-business-time" /> : {daysBetween(card.batchStartDate, card.batchEndDate)} days ({card.ictHours} hrs)</p>
                  <p><strong className="fa fa-clock" /> : {card.batchStartTime} – {card.batchEndTime}</p>
                  <p><strong className="fa fa-map-marker" /> : {card.ictLocation}</p>
                </div>
                <div className="cardBodyRight">
                  <div className="tags">
                    <div className="publicTag">{card.isPublic ? <span>Public</span> : <span>Private</span>}</div>
                    <div className="customizeTag">{card.isCustom ? <span>Custom</span> : <span>Standard</span>}</div>
                    <div className="infoTag">{card.ictStudyMode}</div>
                    <div className="tIdTag">T_Id: {card.id}</div>
                  </div>
                </div>
              </div>

              <div className="card-footer">
                <i className="fa fa-edit editIcon delEditContainer"
                   onClick={e => { e.stopPropagation(); setFormObj(card); }} />
                <i className="fa fa-trash deleteIcon delEditContainer"
                   onClick={e => {
                     e.stopPropagation();
                     if (window.confirm("Delete this training-card?"))
                       dispatch(deleteTrainingCard(card.id));
                   }} />
                <i
                   className={`fas fa-clipboard-check confirmSchedule ${
                    hasSchedule(card.id) ? "disabled" : ""
                   }`}
                   title={
                    hasSchedule(card.id)
                       ? "Schedule already generated"
                       : "Generate Schedule"
                   }
                   onClick={(e) => {
                     e.stopPropagation();
                     if (!hasSchedule(card.id)) {
                       generateSchedule(card);
                     }
                   }}
                 />
                <i
                  className="fas fa-file-invoice-dollar genScard"
                  onClick={e => { e.stopPropagation(); generateSC(card); }} title="Generate Sales Card"/>
                  <i
                    className="fas fa-calendar-alt cal" title="Mark Attendance"
                    onClick={(e) => {
                      e.stopPropagation();
                      setAttTcId(card.id);       // open popup for this training-card
                    }}
                  />
              </div>
            </div>
          );
        })}
      </div>

      {/* pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
            <button key={p}
                    className={p === page ? "active" : ""}
                    onClick={() => setPage(p)}>
              {p}
            </button>
          ))}
        </div>
      )}

      {/* detail popup */}
      {detail && (
        <CompleteTrainingDetail card={detail} onClose={() => setDetail(null)} />
      )}

      {/* add / edit popup */}
      {formObj !== null && (
        <AddEditTrainingCard
          initCardObj={Object.keys(formObj).length ? formObj : null}
          onClose={() => setFormObj(null)}
        />
      )}
      {attTcId !== null && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ maxWidth: "900px" }}>
            <LearnerAttendanceList tcId={attTcId} />
            <button
              className="close-btn fa fa-close"
              onClick={() => setAttTcId(null)}
              style={{ position: "absolute", top: 8, right: 10 }}
            />
          </div>
        </div>
      )}
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
};

export default TrainingCards;
